import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Controller, useForm } from 'react-hook-form';
import ExpandableTextArea from 'components/ExpandableTextArea';

export function OutputNodeForm({ id, data, onUpdateData }) {
  const { formatMessage: msg } = useIntl();

  const { control, setValue, watch } = useForm({
    defaultValues: {
      template: data?.template || ''
    }
  });

  const formValues = watch();

  useEffect(() => {
    onUpdateData?.({
      id,
      data: {
        ...data,
        template: formValues.template
      }
    });
  }, [formValues, data, id, onUpdateData]);

  const clearField = (fieldName) => {
    setValue(fieldName, '');
  };

  return (
    <Stack spacing={1} sx={{ p: 1 }}>
      <Controller
        name="template"
        control={control}
        render={({ field }) => (
          <ExpandableTextArea
            field={field}
            clearField={() => clearField('template')}
            label={msg({ id: 'field.template.label' })}
            control={control}
            minRows={20}
            maxRows={100}
          />
        )}
      />
    </Stack>
  );
}

OutputNodeForm.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    template: PropTypes.string
  }),
  onUpdateData: PropTypes.func.isRequired
};
